var exports = {
  "k": "xe533113f--67ecd7--container",
};

module.exports = exports;
